import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../api/axios';
import { BASE_URL } from '../constants/apiConstants';

interface Region {
  regionid: number;
  regionname: string;
}

interface RegionResponse {
  success: boolean;
  errormessage?: string;
  data: {
    regionlist: Region[];
  };
}

interface RegionState {
  regions: Region[];
  loading: boolean;
  error: string | null;
}

const initialState: RegionState = {
  regions: [],
  loading: false,
  error: null,
};

// Async Thunk to Fetch Regions
export const fetchRegion = createAsyncThunk('region/fetchRegion', async (userId: string) => {
  try {
    const response = await axiosInstance.post<RegionResponse>(
      `${BASE_URL}/api/v1/InitiateMenuPlan/GetRegions`,
      { userid: userId }
    );

    const data = response.data;

    if (!data.success) {
      throw new Error(data.errormessage || 'Failed to fetch regions');
    }

    return data.data.regionlist;
  } catch (error: any) {
    throw new Error(error.response?.data?.errormessage || 'Failed to fetch regions');
  }
});

// Slice
const regionSlice = createSlice({
  name: 'region',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchRegion.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchRegion.fulfilled, (state, action) => {
        state.regions = action.payload;
        state.loading = false;
      })
      .addCase(fetchRegion.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to fetch regions';
      });
  },
});

export default regionSlice.reducer;
